exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:100,300,400,700,900);", ""]);

// module
exports.push([module.id, ".home {\n  align-items: center;\n  display: flex;\n  height: 100vh;\n  justify-content: center;\n  width: 100vw;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n", ""]);

// exports
